export const APP_GALLERY_LINK =
  'https://aircash.eu/huawei-app-gallery/?utm_source=FavBet&amp;utm_medium=web&amp;utm_campaign=isplata';
export const GOOGLE_PLAY_LINK =
  'https://play.google.com/store/apps/details?id=com.aircash.aircash&amp;referrer=utm_source%3DFavBet%26utm_medium%3Dweb%26utm_campaign%3Displata%26utm_content%3D';
export const APP_STORE_LINK =
  'https://apps.apple.com/hr/app/aircash/id1178612530?l=hr';
